import { render, staticRenderFns } from "./CategoryDataTable.vue?vue&type=template&id=0e8e70f2&scoped=true&"
import script from "./CategoryDataTable.vue?vue&type=script&lang=js&"
export * from "./CategoryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDataTable.vue?vue&type=style&index=0&id=0e8e70f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e70f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})
